import { Sidebar, SidebarContent, SidebarHeader, SidebarFooter } from "@/components/ui/sidebar";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { Category, Account } from '@/types';
import { SidebarButtons } from './sidebar/SidebarButtons';
import { FileHandler } from './sidebar/FileHandler';
import { DialogManager } from './sidebar/DialogManager';
import { SidebarSearch } from './sidebar/SidebarSearch';
interface AppSidebarProps {
  categories: Category[];
  accounts: Account[];
  expanded: Set<string>;
  onToggle: (categoryId: string) => void;
  onSetAccounts: React.Dispatch<React.SetStateAction<Account[]>>;
  setCategories?: React.Dispatch<React.SetStateAction<Category[]>>;
}
export function AppSidebar({
  categories,
  accounts,
  expanded,
  onToggle,
  onSetAccounts,
  setCategories
}: AppSidebarProps) {
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);
  const [isExportCSVDialogOpen, setIsExportCSVDialogOpen] = useState(false);
  const [isImportExcelDialogOpen, setIsImportExcelDialogOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleResetAll = () => {
    if (window.confirm('Are you sure you want to reset all data? This action cannot be undone.')) {
      localStorage.clear();
      sessionStorage.clear();
      if (setCategories) {
        setCategories([]);
      }
      onSetAccounts([]);
      localStorage.removeItem('selectedCategory');
      toast.success('All data has been reset');
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      window.location.reload();
    }
  };
  const handleCategoriesImported = (newCategories: Category[]) => {
    if (setCategories && newCategories.length > 0) {
      setCategories(prevCategories => {
        return [...prevCategories, ...newCategories];
      });
    }
  };
  return <Sidebar>
      <SidebarHeader className="bg-[#1C2536] h-16 flex items-center justify-center">
        <img src="/lovable-uploads/a51d509a-2acc-4277-8666-9b9d7c25a346.png" alt="BeeMap Logo" className="w-12 h-12" />
      </SidebarHeader>
      <SidebarContent className="bg-[#1C2536] h-[calc(100vh-12rem)] p-4 space-y-2">
        <SidebarButtons fileInputRef={fileInputRef} onOpenSaveDialog={() => setIsSaveDialogOpen(true)} onOpenExportDialog={() => setIsExportDialogOpen(true)} onOpenExportCSVDialog={() => setIsExportCSVDialogOpen(true)} onOpenImportExcelDialog={() => setIsImportExcelDialogOpen(true)} handleResetAll={handleResetAll} categories={categories} />
      </SidebarContent>
      <SidebarFooter className="bg-[#1C2536] p-4 space-y-4">
        <SidebarSearch categories={categories} />
        <span className="text-white/50 text-sm block">Version 1.6
      </span>
      </SidebarFooter>

      <FileHandler setCategories={setCategories} onSetAccounts={onSetAccounts} expanded={expanded} onToggle={onToggle} fileInputRef={fileInputRef} />

      <DialogManager categories={categories} accounts={accounts} expanded={expanded} isSaveDialogOpen={isSaveDialogOpen} isExportDialogOpen={isExportDialogOpen} isExportCSVDialogOpen={isExportCSVDialogOpen} isImportExcelDialogOpen={isImportExcelDialogOpen} onSaveDialogChange={setIsSaveDialogOpen} onExportDialogChange={setIsExportDialogOpen} onExportCSVDialogChange={setIsExportCSVDialogOpen} onImportExcelDialogChange={setIsImportExcelDialogOpen} onCategoriesImported={handleCategoriesImported} />
    </Sidebar>;
}